import starSvg from '@listening/assets/astro/images/star.svg';
import * as m from '@/paraglide/messages';
import { AccentText } from '../accent-text';
import { voicePortrait } from '../voice-portrait';

export function SqueezeSocialProof() {
  return (
    <section className='px-4 py-12 sm:px-7'>
      <div className='mx-auto max-w-[1000px] text-center'>
        <h2 className='mx-auto mb-2 max-w-[640px] text-[26px] font-extrabold tracking-tight text-balance sm:text-[32px]'>
          {m.funnel_sq_join_heading()}
        </h2>
        <p className='mx-auto max-w-[580px] text-[17px] font-semibold'>
          <AccentText
            className='font-bold text-azure-595'
            text={m.funnel_sq_positioning()}
          />
        </p>
        <div className='mx-auto mt-9 grid max-w-[920px] grid-cols-1 gap-4 text-left md:grid-cols-3'>
          <ReviewCard
            avatar={voicePortrait('Amy')}
            name={m.funnel_sq_rev1_name()}
            quote={m.funnel_sq_rev1_quote()}
            role={m.funnel_sq_rev1_role()}
          />
          <ReviewCard
            avatar={voicePortrait('Hugh')}
            name={m.funnel_sq_rev2_name()}
            quote={m.funnel_sq_rev2_quote()}
            role={m.funnel_sq_rev2_role()}
          />
          <ReviewCard
            avatar={voicePortrait('Scarlett')}
            name={m.funnel_sq_rev3_name()}
            quote={m.funnel_sq_rev3_quote()}
            role={m.funnel_sq_rev3_role()}
          />
        </div>
      </div>
    </section>
  );
}

function ReviewCard({
  avatar,
  name,
  role,
  quote,
}: {
  avatar: string;
  name: string;
  role: string;
  quote: string;
}) {
  return (
    <div className='rounded-xl border border-steel-120 bg-white p-[18px] shadow-md'>
      <div className='mb-2.5 flex items-center gap-2.5'>
        <img
          alt=''
          className='size-[38px] rounded-full object-cover'
          src={avatar}
        />
        <div className='leading-tight'>
          <b className='block text-sm'>{name}</b>
          <span className='text-xs text-steel-700'>{role}</span>
        </div>
      </div>
      <div className='mb-2 flex'>
        <img alt='' className='size-3.5' src={starSvg} />
        <img alt='' className='size-3.5' src={starSvg} />
        <img alt='' className='size-3.5' src={starSvg} />
        <img alt='' className='size-3.5' src={starSvg} />
        <img alt='' className='size-3.5' src={starSvg} />
      </div>
      <p className='text-[14.5px] leading-normal'>"{quote}"</p>
    </div>
  );
}
